/* @flow */
const prefix = str => `station/profile/${str}`;

export const FETCH = prefix('FETCH');
export const FETCH_SUCCESS = prefix('FETCH_SUCCESS');
export const FETCH_FAILURE = prefix('FETCH_FAILURE');

export const FETCH_QUOTAS = prefix('FETCH_QUOTAS');
export const FETCH_QUOTAS_SUCCESS = prefix('FETCH_QUOTAS_SUCCESS');
export const FETCH_QUOTAS_FAILURE = prefix('FETCH_QUOTAS_FAILURE');

export const UPDATE = prefix('UPDATE');
export const UPDATE_SUCCESS = prefix('UPDATE_SUCCESS');
export const UPDATE_FAILURE = prefix('UPDATE_FAILURE');

export const UPDATE_PREFERENCES = prefix('UPDATE_PREFERENCES');
export const UPDATE_PREFERENCES_SUCCESS = prefix('UPDATE_PREFERENCES_SUCCESS');
export const UPDATE_PREFERENCES_FAILURE = prefix('UPDATE_PREFERENCES_FAILURE');

export const SAVE_PASSWORD = prefix('SAVE_PASSWORD');
export const SAVE_PASSWORD_SUCCESS = prefix('SAVE_PASSWORD_SUCCESS');
export const SAVE_PASSWORD_FAILURE = prefix('SAVE_PASSWORD_FAILURE');

export const SUBSCRIBE_FILTER = prefix('SUBSCRIBE_FILTER');
export const SUBSCRIBE_FILTER_SUCCESS = prefix('SUBSCRIBE_FILTER_SUCCESS');
export const SUBSCRIBE_FILTER_FAILURE = prefix('SUBSCRIBE_FILTER_FAILURE');

export const DELETE_IR_FILTER = prefix('DELETE_IR_FILTER');
export const DELETE_IR_FILTER_SUCCESS = prefix('DELETE_IR_FILTER_SUCCESS');
export const DELETE_IR_FILTER_FAILURE = prefix('DELETE_IR_FILTER_FAILURE');

export const ADD_IR_FILTER = prefix('ADD_IR_FILTER');
export const ADD_IR_FILTER_SUCCESS = prefix('ADD_IR_FILTER_SUCCESS');
export const ADD_IR_FILTER_FAILURE = prefix('ADD_IR_FILTER_FAILURE');

export const REGISTER_CHANNEL = prefix('REGISTER_CHANNEL');
export const REGISTER_CHANNEL_SUCCESS = prefix('REGISTER_CHANNEL_SUCCESS');
export const REGISTER_CHANNEL_FAILURE = prefix('REGISTER_CHANNEL_FAILURE');

export const HIDE_UPSELL_MODAL = prefix('HIDE_UPSELL_MODAL');

export const PREMIUM_CONTENT_LOCK_CLICK = prefix('PREMIUM_CONTENT_LOCK_CLICK');



// WEBPACK FOOTER //
// ./src/app/modules/profile/action-types.js